import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Memory Lamp</h3>
          <p>Mang ánh sáng và hương thơm đến không gian sống của bạn</p>
        </div>

        <div className="footer-section">
          <h4>Liên Hệ</h4>
          <ul>
            <li>Email: contact@memorylamp.com</li>
            <li>Điện thoại: (84) 123 456 789</li>
            <li>Địa chỉ: 123 Đường ABC, TP.HCM</li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Theo Dõi</h4>
          <div className="social-links">
            <a href="#"><FaFacebook /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 Memory Lamp. Tất cả quyền được bảo lưu.</p>
      </div>
    </footer>
  );
};

export default Footer;